import { useState, useEffect } from 'react';
import { Card, Row, Col, Typography, Tooltip, Space, message } from 'antd';
import { ReModal, ReButton } from "@/components/refineElement";
import { showDelConfirm, getOnOkFunction } from "@/lib/antdElementFunction";
import DocumentConfig from "@/config/document";
import { dateFormat, getMoment } from "@/lib/dateTime";
import { getLangList } from '@/lib/i18n';
import { openBlobDownloadDialog } from "@/lib/exlsDownload";
import { hasPermission } from "@/lib/permissionUtil";
import { DocumentType } from './types';
import DocumentModal from './DocumentModal';

const {
  getAllDocument,
  createDocument,
  updateDocument,
  deleteDocument,
  downloalDocument,
} = DocumentConfig;

function DocumentShare() {
  const [dataArray, setDataArray] = useState<DocumentType[]>([]);
  const [info, setInfo] = useState({} as DocumentType);
  const [handleType, setHandleType] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const homeT: any = getLangList("home");
  const errorT: any = getLangList("error");
  const okFunction = {
    create: createDocumentFunction,
    update: updateDocumentFunction,
  };

  useEffect(() => {
    getAllDocumentFunction();
  }, []);

  function getAllDocumentFunction() {
    getAllDocument().then((res: any) => {
      const infoArray = res?.value ?? [];
      setDataArray(infoArray);
    });
  };

  function toggleModal(handleType: string = '') {
    setIsModalVisible(!isModalVisible);
    setHandleType(handleType);
  };

  function clickCreate() {
    setInfo({} as DocumentType);
    toggleModal('create');
  };

  const clickEdit = (data: DocumentType) => (e: any) => {
    e.stopPropagation();
    setInfo(data);
    toggleModal('update');
  };

  const clickDelete = (id: number) => () => {
    showDelConfirm(() => deleteDocumentFunction(id));
  };

  function createDocumentFunction(values: any) {
    const { personType, file } = values;
    const params = {
      stringFormat: { personType: personType.length === 2 ? 0 : personType[0] },
      fileFormat: { file },
    };

    createDocument(params).then((res: any) => {
      if (!res.success) {
        return message.error(errorT.failed);
      }
      message.success(errorT.success);
      toggleModal();
      getAllDocumentFunction();
    });
  };

  function updateDocumentFunction(values: any) {
    const { id } = info;
    const { personType } = values;
    const params = {
      personType: personType.length === 2 ? 0 : personType[0], // 0全選  1學生  2 行政人員
      id,
    };

    updateDocument(params).then((res: any) => {
      if (!res.success) {
        return message.error(errorT.failed);
      }
      message.success(errorT.success);
      toggleModal();
      getAllDocumentFunction();
    });
  };

  function deleteDocumentFunction(id: number) {
    deleteDocument(`${id}`).then((res: any) => {
      if (!res.success) {
        return message.error(errorT.failed);
      }
      message.success(errorT.success);
      getAllDocumentFunction();
    });
  };

  const downloalDocumentFunction = (id: number, documentName: string) => () => {
    downloalDocument(`${id}`).then((res: any) => {
      openBlobDownloadDialog(res, documentName);
    });
  };

  return (
    <>
      <Card
        title={homeT.DOCUMENT_SHARE}
        size="small"
        className="document-share-card"
        extra={hasPermission('HOME_DOCUMENT_SHARE_NEW') &&
          <ReButton iconName='plus' onClick={clickCreate} attributeObject={{ size: "small" }} />
        }
      >
        <Row className="home-video-share-list-container" gutter={[12, 12]}>
          {dataArray.map((item: DocumentType, index: number) => {
            const { documentName, createTime, id } = item;
            const dateDetail = getMoment(createTime).format(dateFormat);

            return (
              <Col span={24} key={index}>
                <Row gutter={[24, 24]} wrap={false}>
                  <Col className="home-video-share-list-date" flex={"0 1 112px"}>
                    <Tooltip title={dateDetail}>
                      <Typography.Text ellipsis>{dateDetail}</Typography.Text>
                    </Tooltip>
                  </Col>

                  <Col className="home-video-share-list-title" flex={"1 1 66px"}>
                    <Tooltip title={documentName}>
                      <Typography.Link ellipsis onClick={downloalDocumentFunction(id, documentName)}>
                        {documentName}
                      </Typography.Link>
                    </Tooltip>
                  </Col>

                  <Col>
                    <Space>
                      {hasPermission('HOME_DOCUMENT_SHARE_EDIT') &&
                        <ReButton iconName='edit' onClick={clickEdit(item)} attributeObject={{ size: "small" }} />
                      }

                      {hasPermission('HOME_DOCUMENT_SHARE_DELETE') &&
                        <ReButton iconName='delete' onClick={clickDelete(id)} attributeObject={{ size: "small", type: "danger" }} />
                      }
                    </Space>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Card>

      {isModalVisible &&
        <ReModal
          title={homeT.DOCUMENT}
          onCancel={() => toggleModal()}
          visible={isModalVisible}
          onOk={(data: any) => getOnOkFunction(handleType, data, okFunction)}
          CollectedForm={DocumentModal}
          formProps={{
            handleType,
            info,
          }}
        />
      }
    </>
  );
}

export default DocumentShare;